export const get = <T = any>(object: Record<any, any>, name: string): T => {
  return name.split('.').reduce((acc, item) => (acc ? acc[item] : undefined), object);
};
